import React from 'react';
import { connect } from 'react-redux';
import { Jumbotron, Button, Row, Col, OverlayTrigger, Glyphicon } from 'react-bootstrap';
import { Table, Tr, Td, Th, Thead } from 'reactable';
import _ from 'lodash';

import { gettext } from '../../../i18n/service.js';
import getTooltip from '../../../businessLogic/getTooltip.js';

class UserCardsComponent extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.cards = this.props.cards;
    this.props.getCards(this.props.account.id);

    _.bindAll(this, ['getSelectedCard', 'deleteCard']);
  }

  getSelectedCard(id) {
    this.selectedCard = _.find(this.props.cards, { 'id': id });
    this.forceUpdate();
  }

  flipCreateCard() {
    this.props.router.push('/addCard');
    this.forceUpdate();
  }

  deleteCard() {
    if (!this.selectedCard.default) {
      _.pull(this.props.cards, this.selectedCard);
      this.props.deleteCard(this.props.account.id, this.selectedCard.id);
      this.forceUpdate();
    } else
      return this.props.showMessage({
        message: gettext('YOU-CANT-DELETE-DEFAULT-CARD'),
        level: 'error'
      });
  }

  render() {
    let cards = _.map(this.props.cards, (card) => {
      const isCardSelected = card === this.selectedCard;
      const className = isCardSelected ? 'active' : '';
      if (card.confirmed)
        return (
          <Tr className={className} key={card.id} onClick={(e) => this.getSelectedCard(card.id)}>
            <Td column={gettext('TITLE')}>
              {card.title}
            </Td>
            <Td column={gettext('DEFAULT')}>
              {card.default
                ? <b>{gettext('DEFAULT')}</b>
                : isCardSelected
                  ? <Button bsStyle="primary"
                    onClick={() => {
                      this.props.startSpinner();
                      this.props.makeCardAsDefault(card.id);
                    }}>
                    {gettext('SET-AS-DEFAULT')}
                  </Button>
                  : ''
              }
            </Td>
          </Tr>
        );
    });

    return (
      <div className="dispatcher_profile">
        <Jumbotron>
          <div className="item_head_title">
            <h3>{gettext('CARDS') + ' '}
              <OverlayTrigger placement="top" overlay={getTooltip(gettext('USER-CARDS-TOOLTIP'))}>
                <Glyphicon glyph="question-sign" />
              </OverlayTrigger>
            </h3>
          </div>
          <Row className="center_flex">
            <Col sm={10}>
              <Col sm={12}>
                <div className="table_container">
                  <Table className="company_table table-fixedheader">
                    <Thead>
                      <Th column={gettext('TITLE')}>
                        <span title={gettext('TITLE')}>{gettext('TITLE')}</span>
                      </Th>
                      <Th column={gettext('DEFAULT')}>
                        <span />
                      </Th>
                    </Thead>
                    {cards}
                  </Table>
                </div>
                <div className="milti_controls">
                  <Button className="multi_btn margin_bottom_halfem" onClick={() => { this.flipCreateCard(); }}>+</Button>
                  <Button className="multi_btn margin_bottom_halfem"
                    onClick={() => this.deleteCard()}>
                    -
                   </Button>
                </div>
              </Col>

            </Col>
          </Row>
        </Jumbotron>
      </div>
    );
  }
}

UserCardsComponent.propTypes = {

};

function mapStateToProps(state) {
  return {
    cards: state.appReducer.cards
  };
}

function mapDispatchToProps(dispatch) {
  return {
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserCardsComponent);



// WEBPACK FOOTER //
// ./src/components/settings/components/UserCardsComponent.js